import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Receiving = loadable(() => import('./PSD2Receiving'), {
  fallback: <Loader />,
});
